/**
 * MiniSparkline — tiny inline SVG sparkline for KPI cards.
 *
 * Props:
 * - data: number[] — values to plot
 * - color: string — line color (default teal)
 * - width: number (default 64)
 * - height: number (default 28)
 * - filled: boolean — whether to show area fill (default false)
 */

import React, { useMemo } from 'react';

export default function MiniSparkline({
  data = [],
  color = '#0d9488',
  width = 64,
  height = 28,
  filled = false,
}) {
  const points = useMemo(() => {
    if (data.length < 2) return '';
    const max = Math.max(...data);
    const min = Math.min(...data);
    const range = max - min || 1;
    return data
      .map((v, i) => {
        const x = (i / (data.length - 1)) * width;
        const y = height - ((v - min) / range) * (height - 4) - 2;
        return `${x},${y}`;
      })
      .join(' ');
  }, [data, width, height]);

  if (data.length < 2) return <div style={{ width, height }} />;

  const areaPoints = filled ? `0,${height} ${points} ${width},${height}` : '';

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      style={{ display: 'block' }}
    >
      {filled && <polygon points={areaPoints} fill={`${color}20`} />}
      <polyline
        points={points}
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
